import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Alert from '@mui/material/Alert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid'; 
import MuiAccordion from '@mui/material/Accordion'; 
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save'; 
import CancelIcon from '@mui/icons-material/Close'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from "@mui/material/Typography"; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent'; 
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import './contentPreview.css';
import fetch from "node-fetch"; 
import * as endpoints from '../../../endpoints.js';
import { v4 as uuid } from "uuid"; 
import {format} from 'date-fns'
import './masterPinList.css';

function CustomMenu({callback, data, alert}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleViewActivityLog = () => { 
        setAnchorEl(null);
        callback({
            message_id: data.message_id, 
            root_id: data.root_id, 
            parent_id: data.parent_id,
            message_type: data.message_type,
            application: data.application, 
            group_name: data.group_name, 
            group_id: data.group_id, 
            date: data.date,
            viewer: true,
            general: false,
            pin_list: false
        });
    }
     
    const handleUnpinMessage = () => { 
        const id = data.record_id;
        const pin_type = data.record_id.split("#")[0];
        let query = {
            action_type: "delete",
            id: id,
            pin_type: pin_type
        }     
        const unpinMessage = async () => {
            try {
                const res = await fetch(endpoints.SAVE_PIN_MESSAGE, { 
                    headers: {
                        authorizationToken: endpoints.AUTHORIZATION_TOKEN
                    },
                    method: 'POST',
                    body: JSON.stringify(query)   
                })
                res.json().then((body) => {
                    alert({id: id, status: true, action: "delete"})
                })
            } catch (err) {
                console.log('unpinMessage error:', err)
                alert({id: id, status: false, action: "delete"})
            } 
        }
        unpinMessage();
        setAnchorEl(null);
    } 
     
    return (
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", paddingTop: '4px'}}>
            <IconButton onClick={handleClick}>
                <MoreHorizIcon />
            </IconButton>  
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleViewActivityLog}>View in Activity Log</MenuItem>
                <MenuItem onClick={handleUnpinMessage}>Unpin Message</MenuItem> 
            </Menu>
        </Box> 
    )
}

function CustomEdit({data, dialog}) { 
    const handleClick = () => {  
        dialog({open: true, data: data});
        // Open up modal
    }
    
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", paddingTop: '4px'}}>
                <IconButton onClick={handleClick}>
                    <EditIcon />
                </IconButton>   
            </Box>   
        </>
    )    
}

const renderDate = (date) => {
 if (!date) {
   return '';
 } 
 return format(new Date(date), 'dd/MM/yyyy, p');
}

const Accordion = styled((props) => ( <MuiAccordion disableGutters elevation={0} square {...props} /> ))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

function CustomToolbar() {
  return (
    <GridToolbarContainer> 
      <GridToolbarFilterButton /> 
      <Box sx={{ flexGrow: 1 }} /> 
    </GridToolbarContainer>
  );
} 

function PinTable({rows, columns, loading, callback, alert, dialog}) {   
    if (loading) {
        return (
            <div style={{ height: '100%', width: "300"}}>
                Loading...
            </div>
        )
    }
    return (
        <div style={{ height: '100%', width: "300"}}>
            <DataGrid    
                initialState={{ 
                    pagination: { paginationModel: { pageSize: 5 } },
                }}
                editMode="row"
                rows={rows} 
                columns={columns}
                pageSizeOptions={[5, 10, 30]}       
                disableSelectionOnClick 
                disableRowSelectionOnClick 
                disableColumnResize 
                disableColumnMenu
                slots={{ toolbar: CustomToolbar }}
                sx={{
                    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                        outline: "none !important", 
                    },  
                    "&.MuiDataGrid-root .MuiDataGrid-cell": {
                        whiteSpace: "normal !important",
                        wordWrap: "break-word !important", 
                        display: "flex !important",
                        alignItems: "center !important"  
                    },
                    ".MuiButton-root": {
                        color: "#605958"
                    },
                    "& .MuiDataGrid-row:hover": {
                        backgroundColor: "rgba(218,218,218,0)", 
                    }
                }} 
            />
        </div>    
    )
}

export default function MasterPinList(props) {  
    const [individual, setIndividual] = useState(uuid().slice(0, 4)); 
    const [team, setTeam] = useState(uuid().slice(0, 4));
    const [manning, setManning] = useState(uuid().slice(0, 4));
    const [individualPinsRows, setIndividualPinsRows] = useState([]);
    const [teamPinsRows, setTeamPinsRows] = useState([]);
    const [manningPinsRows, setManningPinsRows] = useState([]);
    const [individualPinsLoading, setIndividualPinsLoading] = useState(true); 
    const [teamPinsLoading, setTeamPinsLoading] = useState(true); 
    const [manningPinsLoading, setManningPinsLoading] = useState(true); 
    const [open, setOpen] = useState(false); 
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const [remarks, setRemarks] = useState("");
    // const handleOpen = () => setOpen(true);   
    const [alert, setAlert] = useState({
        id: "",
        status: false,
        action: "" // "delete" or "update"
    }) 
    
    const fetchPinContent = async (filter) => {
        const res = await fetch(endpoints.ELASTIC, { 
            headers: {
                authorizationToken: endpoints.AUTHORIZATION_TOKEN
            },
            method: 'POST',
            body: JSON.stringify({
                es_query: {
                    _source: [
                        "application",
                        "commsGuid",
                        "commsName",
                        "commsUrl",
                        "es_id", 
                        "message",
                        "messageDatetime",
                        "messageId",
                        "messageResponseType",
                        "messageType",
                        "messageSnippet",
                        "parentMessageId",
                        "rootMessageId" 
                    ],
                    aggs: {},
                    index: "messages.*",
                    query: {
                        bool: {
                            filter: filter,
                            must: [],
                            must_not: [],
                            should: [], 
                        }
                    },
                    "size": 200,
                    "sort": [
                        {
                            "messageDatetime": {
                                "order": "desc",
                                "unmapped_type": "boolean"
                            }
                        }
                    ],
                }
            })   
        }).catch((err) => {
            console.log('POST call failed: ', err.message);
        }); 
        return new Promise((resolve, reject) => {
            res.json().then(body => {   
                let messages = body.hits?.hits; 
                messages = messages.map((message) => { return message._source }); 
                resolve(messages); 
            })
        })  
    }
      
    useEffect(() => {
        setRemarks(dialogData.creator_remarks);
    }, [dialogData])  
    
    useEffect(() => {
        const getIndividualPinnedMessages = async () => {
            const res = await fetch(endpoints.GET_PIN_MESSAGE, { 
                headers: {
                    authorizationToken: endpoints.AUTHORIZATION_TOKEN
                },
                method: "POST",
                body: JSON.stringify({
                    action_type: "get_records_by_creator", 
                    pin_type: "individual", 
                	sort_order: "desc", 
                	creator: props.user.username, 
                	result_size_limit: "200"
                }) 
            }).catch((err) => {
                console.log("getPinnedMessages Error:", err)
            });   
            return new Promise((resolve, reject) => {
                res.json().then(body => {
                    resolve(body); 
                })
            }).catch((err) => console.log("Error:", err));     
        }        
        let temp_pin_metadata = []; 
        let temp_filters = []; 
        getIndividualPinnedMessages().then((res) => { 
            res.map((obj) => { 
                let metadata = {};  
                metadata.record_id = obj.id; // e.g. team#kuja#gcc|WhatsApp|60179083959-1612037230@g.us|298744
                metadata.pin_id = obj.es_record_id; // e.g. Telegram|-1001781035677|1350052
                metadata.date_created = new Date(obj.created_datetime);
                metadata.remarks = obj.creator_remarks;  
                temp_filters.push({ match_phrase: { es_id: obj.es_record_id  }})
                temp_pin_metadata.push(metadata); 
            })    
            let filters = [
                {
                    match_all: {}
                },
                {
                    match_all: {}
                },
                {
                    bool: {
                        should: temp_filters,
                        minimum_should_match: 1
                    }
                }
            ]           
            fetchPinContent(filters).then((res) => { 
                temp_pin_metadata.map(metadata => {
                	const pin_message = res.find((data)=> data.es_id === metadata.pin_id);
                	if (pin_message.es_id.includes("spoc_" || "gcc_")) {
                	    pin_message.es_id = pin_message.es_id.substring(pin_message.es_id.indexOf('|')+1)  
                	} 
                	metadata.id = pin_message.es_id;
                	metadata.pin_content = pin_message.message ? pin_message.message : "[No textual content]"; 
                	metadata.comms_guid = pin_message.commsGuid; // May need to add this info to table
                	metadata.comms_name = pin_message.commsName; // May need to add this info to table
                	metadata.comms_url = pin_message.commsUrl ? pin_message.commsUrl : "";
                	metadata.message_date = new Date(pin_message.messageDatetime); 
                	metadata.message_response_type = pin_message.messageResponseType;  
                	metadata.menu =  
                	    {   
                	       record_id: metadata.record_id, 
                	       message_id: pin_message.messageId,
                	       root_id: pin_message.rootMessageId ? pin_message.rootMessageId : "",
                	       parent_id: pin_message.parentMessageId ? pin_message.parentMessageId : "",
                	       message_type: pin_message.messageResponseType,
                	       application: pin_message.application,
                	       group_name: pin_message.commsName,
                	       group_id:pin_message.commsGuid,
                	       date: typeof pin_message.messageDatetime == "string" ? new Date(parseInt(pin_message.messageDatetime)) : new Date(pin_message.messageDatetime)
                	    };
                	metadata.edit = // This is the query for inserting (updating) a pin
                	    {
                            application: pin_message.application, 
                            comms_guid: pin_message.commsGuid,
                            comms_name: pin_message.commsName,
                            comms_url: pin_message.commsUrl ? pin_message.commsUrl : "", 
                            created_datetime: metadata.date_created.getTime().toString(),
                            created_datetime_str: metadata.date_created.toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+00:00'),
                            creator: props.user.username,
                            creator_remarks: metadata.remarks,
                            message_datetime: pin_message.messageDatetime.toString(), 
          	                message_datetime_str: new Date(pin_message.messageDatetime).toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+00:00'), 
          	                message_id: pin_message.messageId.toString(),
                            es_record_id: metadata.pin_id,
                            pin_type: "individual",
                            team: props.user.team,
                            action_type: "create" 
                	    }
                    return metadata; 
                })  
                setIndividualPinsRows(temp_pin_metadata); 
                setIndividualPinsLoading(false);
            })         
        }); 
    }, [individual])
    
    useEffect(() => {
        const getTeamPinnedMessages = async () => {
            const res = await fetch(endpoints.GET_PIN_MESSAGE, { 
                headers: {
                    authorizationToken: endpoints.AUTHORIZATION_TOKEN
                },
                method: "POST",
                body: JSON.stringify({
                    action_type: "get_records_by_team", 
                    pin_type: "team", 
                	sort_order: "desc", 
                	team: props.user.team, 
                	result_size_limit: "200"
                }) 
            }).catch((err) => {
                console.log("getPinnedMessages Error:", err)
            });   
            return new Promise((resolve, reject) => {
                res.json().then(body => {
                    resolve(body) 
                })
            }).catch((err) => console.log("Error:", err));     
        }        
        let temp_pin_metadata = []; 
        let temp_filters = []; 
        getTeamPinnedMessages().then((res) => { 
            res.map((obj) => { 
                let metadata = {};  
                metadata.record_id = obj.id; // e.g. team#kuja#gcc|WhatsApp|60179083959-1612037230@g.us|298744
                metadata.pin_id = obj.es_record_id; // e.g. Telegram|-1001781035677|1350052
                metadata.pinned_by = obj.creator;
                metadata.date_created = new Date(obj.created_datetime);
                metadata.remarks = obj.creator_remarks;  
                temp_filters.push({ match_phrase: { es_id: obj.es_record_id  }})
                temp_pin_metadata.push(metadata); 
            })    
            let filters = [
                {
                    match_all: {}
                },
                {
                    match_all: {}
                },
                {
                    bool: {
                        should: temp_filters,
                        minimum_should_match: 1
                    }
                }
            ]           
            fetchPinContent(filters).then((res) => {
                temp_pin_metadata.map(metadata => {
                	const pin_message = res.find((data)=> data.es_id === metadata.pin_id);
                	if (pin_message.es_id.includes("spoc_" || "gcc_")) {
                	    pin_message.es_id = pin_message.es_id.substring(pin_message.es_id.indexOf('|')+1)  
                	} 
                	metadata.id = pin_message.es_id;
                	metadata.pin_content = pin_message.message ? pin_message.message : "[No textual content]"; 
                	metadata.comms_guid = pin_message.commsGuid; // May need to add this info to table
                	metadata.comms_name = pin_message.commsName; // May need to add this info to table
                	metadata.message_date = new Date(pin_message.messageDatetime); 
                	metadata.message_response_type = pin_message.messageResponseType;  
                	metadata.menu =  
                	    {   
                	       record_id: metadata.record_id, 
                	       message_id: pin_message.messageId,
                	       root_id: pin_message.rootMessageId ? pin_message.rootMessageId : "",
                	       parent_id: pin_message.parentMessageId ? pin_message.parentMessageId : "",
                	       message_type: pin_message.messageResponseType,
                	       application: pin_message.application,
                	       group_name: pin_message.commsName,
                	       group_id:pin_message.commsGuid,
                	       date: typeof pin_message.messageDatetime == "string" ? new Date(parseInt(pin_message.messageDatetime)) : new Date(pin_message.messageDatetime)
                	    };
                	metadata.edit = // This is the query for inserting (updating) a pin
                	    {
                            application: pin_message.application, 
                            comms_guid: pin_message.commsGuid,
                            comms_name: pin_message.commsName,
                            comms_url: pin_message.commsUrl ? pin_message.commsUrl : "", 
                            created_datetime: metadata.date_created.getTime().toString(),
                            created_datetime_str: metadata.date_created.toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+00:00'),
                            creator: metadata.pinned_by,
                            creator_remarks: metadata.remarks,
                            message_datetime: pin_message.messageDatetime.toString(), 
          	                message_datetime_str: new Date(pin_message.messageDatetime).toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+00:00'), 
          	                message_id: pin_message.messageId.toString(),
                            es_record_id: metadata.pin_id,
                            pin_type: "team",
                            team: props.user.team,
                            action_type: "create" 
                	    }                	    
                    return metadata; 
                }) 
                setTeamPinsRows(temp_pin_metadata); 
                setTeamPinsLoading(false);
            })         
        }); 
    }, [team]) 

    useEffect(() => {
        console.log("test2")
        const getManningPinnedMessages = async () => {
            const res = await fetch(endpoints.GET_PIN_MESSAGE, { 
                headers: {
                    authorizationToken: endpoints.AUTHORIZATION_TOKEN
                },
                method: "POST",
                body: JSON.stringify({
                    action_type: "get_records_by_team", 
                    pin_type: "team", 
                	sort_order: "desc", 
                	team: "manning", 
                	result_size_limit: "200"
                }) 
            }).catch((err) => {
                console.log("getPinnedMessages Error:", err)
            });   
            return new Promise((resolve, reject) => {
                res.json().then(body => {
                    resolve(body) 
                })
            }).catch((err) => console.log("Error:", err));     
        }        
        let temp_pin_metadata = []; 
        let temp_filters = []; 
        getManningPinnedMessages().then((res) => { 
            console.log("test")
            res.map((obj) => { 
                let metadata = {};  
                metadata.record_id = obj.id; // e.g. team#kuja#gcc|WhatsApp|60179083959-1612037230@g.us|298744
                metadata.pin_id = obj.es_record_id; // e.g. Telegram|-1001781035677|1350052
                metadata.pinned_by = obj.creator;
                metadata.date_created = new Date(obj.created_datetime);
                metadata.remarks = obj.creator_remarks;  
                temp_filters.push({ match_phrase: { es_id: obj.es_record_id  }})
                temp_pin_metadata.push(metadata); 
            })    
            let filters = [
                {
                    match_all: {}
                },
                {
                    match_all: {}
                },
                {
                    bool: {
                        should: temp_filters,
                        minimum_should_match: 1
                    }
                }
            ]           
            fetchPinContent(filters).then((res) => {
                temp_pin_metadata.map(metadata => {
                	const pin_message = res.find((data)=> data.es_id === metadata.pin_id);
                	if (pin_message.es_id.includes("spoc_" || "gcc_")) {
                	    pin_message.es_id = pin_message.es_id.substring(pin_message.es_id.indexOf('|')+1)  
                	} 
                	metadata.id = pin_message.es_id;
                	metadata.pin_content = pin_message.message ? pin_message.message : "[No textual content]"; 
                	metadata.comms_guid = pin_message.commsGuid; // May need to add this info to table
                	metadata.comms_name = pin_message.commsName; // May need to add this info to table
                	metadata.message_date = new Date(pin_message.messageDatetime); 
                	metadata.message_response_type = pin_message.messageResponseType;  
                	metadata.menu =  
                	    {   
                	       record_id: metadata.record_id, 
                	       message_id: pin_message.messageId,
                	       root_id: pin_message.rootMessageId ? pin_message.rootMessageId : "",
                	       parent_id: pin_message.parentMessageId ? pin_message.parentMessageId : "",
                	       message_type: pin_message.messageResponseType,
                	       application: pin_message.application,
                	       group_name: pin_message.commsName,
                	       group_id: pin_message.commsGuid,
                	       date: typeof pin_message.messageDatetime == "string" ? new Date(parseInt(pin_message.messageDatetime)) : new Date(pin_message.messageDatetime)
                	    };
                	metadata.edit = // This is the query for inserting (updating) a pin
                	    {
                            application: pin_message.application, 
                            comms_guid: pin_message.commsGuid,
                            comms_name: pin_message.commsName,
                            comms_url: pin_message.commsUrl ? pin_message.commsUrl : "", 
                            created_datetime: metadata.date_created.getTime().toString(),
                            created_datetime_str: metadata.date_created.toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+00:00'),
                            creator: metadata.pinned_by,
                            creator_remarks: metadata.remarks,
                            message_datetime: pin_message.messageDatetime.toString(), 
          	                message_datetime_str: new Date(pin_message.messageDatetime).toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+00:00'), 
          	                message_id: pin_message.messageId.toString(),
                            es_record_id: metadata.pin_id,
                            pin_type: "team",
                            team: "manning",
                            action_type: "create" 
                	    }                	    
                    return metadata; 
                }) 
                setManningPinsRows(temp_pin_metadata); 
                setManningPinsLoading(false);
            })         
        }); 
    }, [manning])      
    
    const renderIndividualPins = (expanded) => {
        if (expanded) { 
            // setIndividualPinsLoading(true);
            setIndividual(uuid().slice(0, 4));
        }
    }
    
    const renderTeamPins = (expanded) => {
        if (expanded) {
            // setTeamPinsLoading(true);
            setTeam(uuid().slice(0, 4));
        }        
    } 

    const renderManningPins = (expanded) => {
        if (expanded) {
            // setTeamPinsLoading(true);
            setManning(uuid().slice(0, 4));
        }        
    }   
     
    const handleCloseAlert = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      } 
      setOpen(false);
    }; 
    
    const handleAlertCallback = (value) => { 
        setOpen(true);
        setAlert(value);
        renderIndividualPins(true); 
        renderTeamPins(true);
    }
    
    const handleDialogCallback = (value) => {
        setDialogData(value.data);
        setOpenDialog(value.open);
    }
    
    const handleCloseDialog = () => {
        setRemarks(dialogData.creator_remarks);
        setOpenDialog(false); 
    }
    
    const updatePin = async (updated_pin) => { 
        const res = await fetch(endpoints.SAVE_PIN_MESSAGE, { 
            headers: {
                authorizationToken: endpoints.AUTHORIZATION_TOKEN
            },
            method: 'POST',
            body: JSON.stringify(updated_pin)   
        }).catch((err) => { 
        console.log('POST call failed: ', err.message);
        });  
        return new Promise((resolve, reject) => {
            res.json().then(body => {
                let type = updated_pin.pin_type;
                let team = updated_pin.team; 
                if (type === "team" && team === "manning") {
                    renderManningPins(true);
                } else if (type === "team") {
                    renderTeamPins(true);
                } else if (type === "individual") {
                    renderIndividualPins(true); 
                }  
                setOpenDialog(false);
                setAlert({
                    id: "",
                    status: true,
                    action: "update"
                }) 
                setOpen(true);
                resolve(body);  
            }).catch((err) => { 
            console.log('insertPinnedMessage error:', err);
            setAlert({
                id: "",
                status: false,
                action: "update"
            })
            setOpen(true);
        })
      })  
    }
    
    const handleUpdatePinRemarks = () => {
        let updated_pin = dialogData;
        updated_pin.creator_remarks = remarks;  
        updatePin(updated_pin);  
        setOpenDialog(false);
    }
    
    const individualPinsColumns = [
        {
            field: "id",
            headerName: "Pin ID", 
            minWidth: 300,
            flex: 2,
            sortable: true, 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },        
        {
            field: "pin_content",
            headerName: "Pin Content",
            minWidth: 500,
            flex: 5,
            sortable: true, 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "remarks",
            headerName: "Remarks",
            minWidth: 300,
            flex: 3,
            sortable: true, 
            editable: true,
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value.trim() ? params.value : <i>No remarks added.</i>}</Typography> 
            )
        },         
        {
            field: "date_created",
            headerName: "Date Created", 
            minWidth: 150,
            flex: 2,
            sortable: true, 
            type: "date", 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{renderDate(params.value)}</Typography> 
            )
        },   
        {
            field: "menu", 
            headerName: "", 
            sortable: false, 
            minWidth: 50, 
            filterable: false,
            flex: 0.5,
            renderCell: (params) => (<CustomMenu callback={props.callback} data={params.value} alert={handleAlertCallback}/>)  
        },  
        {
            field: "edit", 
            headerName: "", 
            sortable: false, 
            minWidth: 50, 
            filterable: false,
            flex: 0.5,
            renderCell: (params) => (<CustomEdit data={params.value} dialog={handleDialogCallback}/>)  
        },      
    ];   
    
    const teamPinsColumns =  [
        {
            field: "id",
            headerName: "Pin ID", 
            minWidth: 300,
            flex: 2,
            sortable: true, 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },        
        {
            field: "pin_content",
            headerName: "Pin Content",
            minWidth: 500,
            flex: 5,
            sortable: true, 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "remarks",
            headerName: "Remarks",
            minWidth: 300,
            flex: 3,
            sortable: true, 
            editable: true,
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value.trim() ? params.value : <i>No remarks added.</i>}</Typography> 
            )
        },       
        {
            field: "pinned_by",
            headerName: "Pinned By",
            minWidth: 200,
            flex: 2,
            sortable: true, 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },        
        {
            field: "date_created",
            headerName: "Date Created", 
            minWidth: 150,
            flex: 2,
            sortable: true, 
            type: "date", 
            renderCell: (params) => ( 
                <Typography className="typography-multiline">{renderDate(params.value)}</Typography> 
            )
        },   
        {
            field: "menu", 
            headerName: "", 
            sortable: false, 
            minWidth: 50, 
            filterable: false,
            flex: 0.5,
            renderCell: (params) => (<CustomMenu callback={props.callback} data={params.value} alert={handleAlertCallback}/>)  
        },  
        {
            field: "edit", 
            headerName: "", 
            sortable: false, 
            minWidth: 50, 
            filterable: false,
            flex: 0.5,
            renderCell: (params) => (<CustomEdit data={params.value} dialog={handleDialogCallback}/>)  
        },      
    ]; 
    
    // const manningPinsColumns =  [
    //     {
    //         field: "id",
    //         headerName: "Pin ID", 
    //         minWidth: 300,
    //         flex: 2,
    //         sortable: true, 
    //         renderCell: (params) => ( 
    //             <Typography className="typography-multiline">{params.value}</Typography> 
    //         )
    //     },        
    //     {
    //         field: "pin_content",
    //         headerName: "Pin Content",
    //         minWidth: 500,
    //         flex: 5,
    //         sortable: true, 
    //         renderCell: (params) => ( 
    //             <Typography className="typography-multiline">{params.value}</Typography> 
    //         )
    //     },
    //     {
    //         field: "remarks",
    //         headerName: "Remarks",
    //         minWidth: 300,
    //         flex: 3,
    //         sortable: true, 
    //         editable: true,
    //         renderCell: (params) => ( 
    //             <Typography className="typography-multiline">{params.value.trim() ? params.value : <i>No remarks added.</i>}</Typography> 
    //         )
    //     },       
    //     {
    //         field: "pinned_by",
    //         headerName: "Pinned By",
    //         minWidth: 200,
    //         flex: 2,
    //         sortable: true, 
    //         renderCell: (params) => ( 
    //             <Typography className="typography-multiline">{params.value}</Typography> 
    //         )
    //     },        
    //     {
    //         field: "date_created",
    //         headerName: "Date Created", 
    //         minWidth: 150,
    //         flex: 2,
    //         sortable: true, 
    //         type: "date", 
    //         renderCell: (params) => ( 
    //             <Typography className="typography-multiline">{renderDate(params.value)}</Typography> 
    //         )
    //     },   
    //     {
    //         field: "menu", 
    //         headerName: "", 
    //         sortable: false, 
    //         minWidth: 50, 
    //         filterable: false,
    //         flex: 0.5,
    //         renderCell: (params) => (<CustomMenu callback={props.callback} data={params.value} alert={handleAlertCallback}/>)  
    //     },  
    //     {
    //         field: "edit", 
    //         headerName: "", 
    //         sortable: false, 
    //         minWidth: 50, 
    //         filterable: false,
    //         flex: 0.5,
    //         renderCell: (params) => (<CustomEdit data={params.value} dialog={handleDialogCallback}/>)  
    //     },      
    // ];
     
    return ( 
        <>        
            <AppBar position="static" sx={{ backgroundColor: "#605958", marginTop: '0.5rem', borderRadius: '10px 10px 0 0' }} elevation={0}> 
                <Toolbar sx={{ "&.MuiToolbar-root": { padding: "0 10px 0 20px" }}}variant="dense"> 
                    <div className='chatlog-appbar' color="white">
                        <IconButton
                            size="small" 
                            edge="start"
                            color="inherit" 
                            sx={{ mr: 2 }}
                            onClick={() => { props.callback({viewer: false, general: false, pin_list: false}) }}
                        >
                            <ArrowBackIcon />
                        </IconButton>  
                        <div className='chatlog-header'> 
                            Master Pin List 
                        </div>   
                        <div></div>
                    </div>
                </Toolbar>
            </AppBar> 
            <Box bgcolor="white" className='chatlog'>
                <div className='content-accordion'> 
                    <Accordion elevation={0} disableGutters onChange={(event, expanded) => renderIndividualPins(expanded)}>
                        <AccordionSummary
                          expandIcon={<ArrowDropDownIcon />} 
                          sx={{ backgroundColor: '#f5f5f5' }}
                        >
                            <div className='sub-header'>
                                My Pins
                            </div>
                        </AccordionSummary>
                        <AccordionDetails> 
                            <PinTable 
                                rows={individualPinsRows} 
                                columns={individualPinsColumns} 
                                loading={individualPinsLoading} 
                                callback={props.callback} 
                                alert={handleAlertCallback}  
                            /> 
                        </AccordionDetails>
                    </Accordion>   
                    <Accordion elevation={0} disableGutters onChange={(event, expanded) => renderTeamPins(expanded)}>
                        <AccordionSummary
                          expandIcon={<ArrowDropDownIcon />} 
                          sx={{ backgroundColor: '#f5f5f5' }}
                        >
                            <div className='sub-header'>
                                Team Pins
                            </div>
                        </AccordionSummary>
                        <AccordionDetails> 
                            <PinTable 
                                rows={teamPinsRows} 
                                columns={teamPinsColumns} 
                                loading={teamPinsLoading} 
                                callback={props.callback} 
                                alert={handleAlertCallback} 
                            />
                        </AccordionDetails>
                    </Accordion>   
                    <Accordion elevation={0} disableGutters onChange={(event, expanded) => renderManningPins(expanded)}>
                        <AccordionSummary
                          expandIcon={<ArrowDropDownIcon />} 
                          sx={{ backgroundColor: '#f5f5f5' }}
                        >
                            <div className='sub-header'>
                                Manning Pins
                            </div>
                        </AccordionSummary>
                        <AccordionDetails> 
                            <PinTable 
                                rows={manningPinsRows} 
                                columns={teamPinsColumns} 
                                loading={manningPinsLoading} 
                                callback={props.callback} 
                                alert={handleAlertCallback} 
                            />
                        </AccordionDetails>
                    </Accordion>                       
                </div>
            </Box>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                  onClose={handleCloseAlert}
                  severity={alert.status ? "success" : "error"}
                  sx={{ width: '100%' }}
                >
                    { alert.action === "delete" ? 
                        alert.status ? 
                            <div>
                                Successfully unpinned message {alert.id}
                            </div>
                            : 
                            <div>
                                Failed to unpin message {alert.id}
                            </div> 
                    : alert.action === "update" ?
                        alert.status ?
                            <div>
                                Successfully updated pin 
                            </div>    
                            :
                            <div>
                                Failed to update pin
                            </div>
                    :
                    <></>
                    } 
                </Alert>
            </Snackbar> 
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                fullWidth={"sm"}
                maxWidth={"sm"}
                slotProps={{
                  paper: {
                    component: 'form',
                    onSubmit: (event) => {
                      event.preventDefault(); 
                      handleCloseDialog();
                    },
                  },
                }}
            >
                <DialogTitle>Edit Remarks</DialogTitle>
                <DialogContent> 
                    <TextField
                        autoFocus
                        required
                        margin="dense" 
                        fullWidth
                        variant="standard"
                        defaultValue={dialogData.creator_remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Box sx={{display: "flex", flexDirection: "row", gap: "10px", margin: "20px"}}> 
                        <Button className="dialog-button-master-pin" onClick={handleCloseDialog} startIcon={<CancelIcon sx={{marginLeft: "10px"}} />}>
                            <div className="dialog-button-text">
                                Cancel
                            </div>
                        </Button>
                        <Button className="dialog-button-master-pin" onClick={handleUpdatePinRemarks} startIcon={<SaveIcon sx={{marginLeft: "10px"}} />}>
                            <div className="dialog-button-text">
                                Update
                            </div>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>        
        </>
    );
} 


//   columnVisibilityModel={{ 
//     menu: false,  
//   }}     
            
// pin_content, remarks, pinned_by, date_created
